import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import MyQR from '~/pages/MyQR/MyQR';
import MyQRDetail from '~/pages/MyQRDetail/MyQRDetail';

import ProtectedRoute from './ProtectedRoute';

const MY_QR_ROUTES: RouteObject[] = [
  {
    path: PATH.QR.MAIN,
    element: (
      <ProtectedRoute>
        <MyQR />
      </ProtectedRoute>
    ),
  },
  {
    path: PATH.QR.DETAIL,
    element: (
      <ProtectedRoute>
        <MyQRDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: PATH.QR.FOLDER,
    element: (
      <ProtectedRoute>
        <MyQR />
      </ProtectedRoute>
    ),
  },
];

export { MY_QR_ROUTES };
